export default __webpack_public_path__ + "static/media/kyselyt-darkblue.5f073181.svg";